import { Col } from 'reactstrap';

export default Col;
